import { Upload } from './Upload';
import AWS from 'aws-sdk';
import { useState } from 'react';

const S3_BUCKET = 'multi-services';
const REGION = 'eu-north-1';
const ACCESS_KEY = 'AKIAUPBEGHTX53TA3Z3M';
const SECRET_ACCESS_KEY = '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';

AWS.config.update({
  accessKeyId: ACCESS_KEY,
  secretAccessKey: SECRET_ACCESS_KEY,
});

const myBucket = new AWS.S3({
  params: { Bucket: S3_BUCKET },
  region: REGION,
});

const config = {
  bucketName: S3_BUCKET,
  region: REGION,
  accessKeyId: ACCESS_KEY,
  secretAccessKey: SECRET_ACCESS_KEY,
};

export const useAwsUpload = () => {
  const [loading, setLoading] = useState(false);

  const upload = async (file: File) => {
    setLoading(true);
    const result = await Upload.uploadImage(file);
    setLoading(false);
    return result;
  };

  return { loading, upload };
};
